export default __webpack_public_path__ + "static/media/NunitoSans-Regular.a427ddbe.ttf";